import React from "react";
import "./About.css";
import Banner from "../Banner/Banner";

const About = () => {
  const highlights = [
    {
      icon: "🚀",
      title: "Growth-Focused",
      desc: "Every page is structured to build credibility, guide visitors naturally, and turn interest into real enquiries.",
    },
    {
      icon: "🎯",
      title: "Design Meets Strategy",
      desc: "Sharp visuals paired with clear, purposeful messaging — so your site looks great and performs with intent.",
    },
    {
      icon: "⚙️",
      title: "Reliable & Scalable",
      desc: "Fast, mobile-optimised, and built to grow — your website handles more traffic without ever slowing down.",
    },
  ];

  const steps = [
    "Understand your goals, audience, and competitors",
    "Design a clean, focused, conversion-ready layout",
    "Build a fast, fully responsive website",
    "Refine, test thoroughly, and launch with confidence",
  ];

  return (
    <section className="aboutv6">
      <div className="av6-wrap">
        {/* Top Section */}
        <div className="av6-top">
          <div className="av6-copy">
            <span className="av6-badge">Who We Are</span>
            <h1 className="av6-title">
              Purposeful websites
              <span> built to grow your business</span>
            </h1>
            <p className="av6-sub">
              WebDigi Solutions was built on one clear belief: a website should
              be a business asset — not just a digital brochure. We create
              clean, strategic websites that attract the right people, build
              trust fast, and convert consistently.
            </p>

            <div className="av6-actions">
              <a href="/contact" className="av6-btn av6-btn-primary">
                Let's Talk
              </a>
              <a href="/services" className="av6-btn av6-btn-secondary">
                Explore Services
              </a>
            </div>
          </div>

          <div className="av6-feature-card">
            <div className="av6-feature-grid">
              <div className="av6-mini-card">
                <span>Focus</span>
                <strong>Clean & strategic</strong>
              </div>
              <div className="av6-mini-card">
                <span>Approach</span>
                <strong>Design with purpose</strong>
              </div>
              <div className="av6-mini-card">
                <span>Priority</span>
                <strong>Speed & clarity</strong>
              </div>
              <div className="av6-mini-card">
                <span>Goal</span>
                <strong>Measurable business growth</strong>
              </div>
            </div>
          </div>
        </div>

        {/* Story Section */}
        <section className="av6-story">
          <div className="av6-story-card">
            <p className="av6-eyebrow">Our Mission</p>
            <h2>Great design paired with strategy is what actually grows your business</h2>
            <p>
              We build every site with a clear purpose: attract the right
              people, communicate your value with clarity, and make it easy for
              them to take the next step.
            </p>
          </div>

          <div className="av6-story-card">
            <p className="av6-eyebrow">How We Work</p>
            <ul className="av6-check-list">
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* Highlights */}
        <section className="av6-highlights">
          {highlights.map((item) => (
            <article className="av6-highlight" key={item.title}>
              <div className="av6-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </article>
          ))}
        </section>

        {/* Bottom Section */}
        <section className="av6-bottom">
          <div className="av6-bottom-left">
            <p className="av6-eyebrow">Why Choose Us</p>
            <h2>Quality work, clear process, results that matter</h2>
            <p>
              We focus on what actually moves the needle — strategic design,
              fast performance, and a transparent process that keeps you fully
              informed at every stage.
            </p>
          </div>

          <div className="av6-stats">
            <div className="av6-stat">
              <strong>30+</strong>
              <span>projects delivered</span>
            </div>
            <div className="av6-stat">
              <strong>4.9★</strong>
              <span>client satisfaction</span>
            </div>
            <div className="av6-stat">
              <strong>Fast</strong>
              <span>turnaround & support</span>
            </div>
          </div>
        </section>
      </div>

      <Banner />
    </section>
  );
};

export default About;
